import React from 'react';
import '../styles/style.css'
import { SiteFooter } from '../components/footer.js';
import { SiteHeader } from '../components/header.js';
import { Featuredtimeelapsed } from '../components/featuredtime.js';
import { Makerslist } from '../components/makers.js';
import { Urllink } from '../components/urllink.js';
import { useQuery, gql } from '@apollo/client';
import ReactStars from 'react-rating-stars-component';
import { FaComment } from 'react-icons/fa';
import { TiArrowSortedUp } from 'react-icons/ti';
import { CountDownTimer } from '../components/countdowntimer.js'
import { Helmet } from "react-helmet"

let currentdatetime = new Date();
let currentyear = currentdatetime.getUTCFullYear();
let currentmonth = currentdatetime.getUTCMonth();
let currentdate = currentdatetime.getUTCDate();
let hours = 8;
let minutesandseconds = 0;
let dateone = new Date(Date.UTC(currentyear, currentmonth, currentdate, hours, minutesandseconds, minutesandseconds));
let dateoneplus = new Date(Date.UTC(currentyear, currentmonth, currentdate, hours, minutesandseconds, minutesandseconds));
dateoneplus = new Date(dateoneplus.setTime(dateoneplus.getTime()+86399000));
let dateoneminus = new Date(Date.UTC(currentyear, currentmonth, currentdate, hours, minutesandseconds, minutesandseconds));
dateoneminus = new Date(dateoneminus.setTime(dateoneminus.getTime()-86400000));
let dateonesecondminus = new Date(Date.UTC(currentyear, currentmonth, currentdate, hours, minutesandseconds, minutesandseconds));
dateonesecondminus = new Date(dateonesecondminus.setTime(dateonesecondminus.getTime()-1000));

let dateonestring = dateone.toISOString();
let dateoneplusstring = dateoneplus.toISOString();
let dateoneminusstring = dateoneminus.toISOString();
let dateonesecondminusstring = dateonesecondminus.toISOString();

let postafterdate, postbeforedate;

if (currentdatetime >= dateone) {
  postafterdate = dateonestring;
  postbeforedate = dateoneplusstring;
} else {
  postafterdate = dateoneminusstring;
  postbeforedate = dateonesecondminusstring;
}

let dateonedatestring = dateone.toDateString();
let dateoneminusdatestring = dateoneminus.toDateString();

let featureddate;

if (currentdatetime >= dateone) {
  featureddate = dateonedatestring;
} else {
  featureddate = dateoneminusdatestring;
}

export const DAILY_POSTS = gql`
query dailyposts ($cursor: String, $postbef: DateTime, $postaft: DateTime) {
  posts(first: 20, after: $cursor, postedBefore: $postbef, postedAfter: $postaft, order: FEATURED_AT, featured: true) {
    totalCount
    edges {
      node {
        featuredAt
        name
        votesCount
        url
        id
        commentsCount
        makers {
          name
        }
        reviewsCount
        reviewsRating
        tagline
        user {
          name
          profileImage
          url
        }
        thumbnail {
          url
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;

export default () => {
  const { loading, error, data, fetchMore } = useQuery(DAILY_POSTS, {
    variables: {
      cursor: null,
      postaft: postafterdate,
      postbef: postbeforedate
    },
    pollInterval: 300000
  });

  if (loading) return ((
    <div>
      <Helmet>
        <title>Product Hunt Every Day Gems | Home</title>
        <meta name="description" content="A simple realtime view of every day's featured products on Product Hunt in chronological order from newest to oldest"></meta>
        <meta name="author" content="Manish Bharvey"></meta>
      </Helmet>
      <div id="header" className="container d-flex justify-content-between">
        <div><SiteHeader /></div>
        <div className="align-self-center mt-n2"><h6 className="text-secondary">Auto refreshing now</h6></div>
      </div>
      <div className="jumbotron mt-n3 jumbocolor">
        <div className="container d-flex justify-content-between">
          <h1 className="text-body font-weight-bold">{featureddate}</h1>
          <div className="align-self-center">
            <a href="https://www.producthunt.com/posts/product-hunt-every-day-gems?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-product-hunt-every-day-gems" target="_blank" rel="noreferrer"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=273957&theme=dark" alt="Product Hunt Every Day Gems - A view of PH daily featured products from newest to oldest | Product Hunt" style={{width: "250px", height: "54px"}} width="250" height="54" /></a>
          </div>
        </div>
      </div>
      <div className="container table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col" colSpan="2" className="text-center">Product</th>
              <th scope="col" className="text-center">Hunter</th>
              <th scope="col">Makers</th>
              <th scope="col" className="text-center">Upvotes</th>
              <th scope="col" className="text-center">Rating</th>
              <th scope="col" className="text-center">Featured</th>
            </tr>
          </thead>
        </table>
      </div>
      <h5 className="container text-primary">Please hang on for a few seconds.<br></br><br></br>We are loading product information from Product Hunt...</h5>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <br></br>
      <div id="footer">
        <SiteFooter />
      </div>
    </div>
  ));

  if (error) return ((
    <div>
      <Helmet>
        <title>Product Hunt Every Day Gems | Home</title>
        <meta name="description" content="A simple realtime view of every day's featured products on Product Hunt in chronological order from newest to oldest"></meta>
        <meta name="author" content="Manish Bharvey"></meta>
      </Helmet>
      <div id="header" className="container d-flex justify-content-between">
        <div><SiteHeader /></div>
        <div className="align-self-center mt-n2"><CountDownTimer /></div>
      </div>
      <div className="jumbotron mt-n3 jumbocolor">
        <div className="container d-flex justify-content-between">
          <h1 className="text-body font-weight-bold">{featureddate}</h1>
          <div className="align-self-center">
            <a href="https://www.producthunt.com/posts/product-hunt-every-day-gems?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-product-hunt-every-day-gems" target="_blank" rel="noreferrer"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=273957&theme=dark" alt="Product Hunt Every Day Gems - A view of PH daily featured products from newest to oldest | Product Hunt" style={{width: "250px", height: "54px"}} width="250" height="54" /></a>
          </div>
        </div>
      </div>
      <div className="container table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col" colSpan="2" className="text-center">Product</th>
              <th scope="col" className="text-center">Hunter</th>
              <th scope="col">Makers</th>
              <th scope="col" className="text-center">Upvotes</th>
              <th scope="col" className="text-center">Rating</th>
              <th scope="col" className="text-center">Featured</th>
            </tr>
          </thead>
        </table>
      </div>
      <div className="container">
        <h4 className="p-2 m-2 text-danger">Oh! It's completely our bad.</h4>
        <h6 className="p-2 m-2 text-danger">We are really sorry for this experience.</h6>
        <p className="lead p-2 m-2"><br></br>We are facing trouble in getting data from Product Hunt.<br></br><br></br>We request you to try after 5 minutes.<br></br><br></br>Additionally, we will automatically try to refetch the data after 5 minutes.</p>
      </div>
      <div id="footer">
        <SiteFooter />
      </div>
    </div>
  ));

  return ((
    <div>
      <Helmet>
        <title>Product Hunt Every Day Gems | Home</title>
        <meta name="description" content="A simple realtime view of every day's featured products on Product Hunt in chronological order from newest to oldest"></meta>
        <meta name="author" content="Manish Bharvey"></meta>
      </Helmet>
      <div id="header" className="container d-flex justify-content-between">
        <div><SiteHeader /></div>
        <div className="align-self-center mt-n2"><CountDownTimer /></div>
      </div>
      <div className="jumbotron mt-n3 jumbocolor">
        <div className="container d-flex justify-content-between">
          <h1 className="text-body font-weight-bold">{featureddate}</h1>
          <div className="align-self-center">
            <a href="https://www.producthunt.com/posts/product-hunt-every-day-gems?utm_source=badge-featured&utm_medium=badge&utm_souce=badge-product-hunt-every-day-gems" target="_blank" rel="noreferrer"><img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=273957&theme=dark" alt="Product Hunt Every Day Gems - A view of PH daily featured products from newest to oldest | Product Hunt" style={{width: "250px", height: "54px"}} width="250" height="54" /></a>
          </div>
        </div>
      </div>
      <div className="container mb-2">
        <h3 className="text-secondary pb-3">Total Featured Products: <span className="text-primary">{data.posts.totalCount}</span></h3>
      </div>
      <div className="container table-responsive">
        <table className="table table-hover">
          <thead>
            <tr>
              <th scope="col" colSpan="2" className="text-center">Product</th>
              <th scope="col" className="text-center">Hunter</th>
              <th scope="col">Makers</th>
              <th scope="col" className="text-center">Upvotes</th>
              <th scope="col" className="text-center">Rating</th>
              <th scope="col" className="text-center">Featured</th>
            </tr>
          </thead>
          <tbody>
            { 
              data.posts.edges.map(({ node }) => (
                <tr key={node.id}> 
                  <td className="text-center align-middle">
                    <img src={node.thumbnail.url} height="120px" width="120px" alt={node.name} className="img-thumbnail" />
                  </td>
                  <td>
                    <h4><Urllink inlink={node.url} urlname={node.name} /></h4>
                    <p className="lead text-muted pt-2">{node.tagline}</p>
                    <FaComment color="gray"/><span className="text-secondary font-weight-bold">    {node.commentsCount}</span>
                  </td>
                  <td className="text-center align-middle">
                    <img src={node.user.profileImage} height="60px" width="60px" alt={node.user.name} className="img-thumbnail" /> 
                    <h6 className="pt-3"><Urllink inlink={node.user.url} urlname={node.user.name} /></h6>
                  </td>
                  <td className="text-left align-middle">
                    <Makerslist makerslist={node.makers} />
                  </td>
                  <td className="text-center align-middle">
                    <TiArrowSortedUp size="1.6rem"/>
                    <h6 className="font-weight-bold">{node.votesCount}</h6>
                  </td>
                  <td className="text-center align-middle">
                    <ReactStars count={5} value={node.reviewsRating} size={24} activeColor="#16A809" edit={false} isHalf={true} a11y={false} />
                    <h6 className="text-info pt-2">({node.reviewsCount} Reviews)</h6>
                  </td>
                  <td className="text-center align-middle">
                    <Featuredtimeelapsed featureddatetime={node.featuredAt} />
                  </td>
                </tr>
              ))
            }
          </tbody>
        </table>
        <hr className="my-4"></hr>
        { data.posts.pageInfo.hasNextPage === true ? 
        <button type="button" className="btn d-block btn-success btn-lg mx-auto" onClick={() => {
          const {endCursor} = data.posts.pageInfo;
          fetchMore({
            variables: { cursor: endCursor },
            updateQuery: (prevResult, {fetchMoreResult}) => {
              fetchMoreResult.posts.edges = [
                ...prevResult.posts.edges,
                ...fetchMoreResult.posts.edges
              ];
              return fetchMoreResult;
            }
          })
          }}>Show more products</button>
        : 
        ''
        }
      </div>
      <div id="footer">
        <SiteFooter />
      </div>
    </div>
  ));
};